export default __webpack_public_path__ + "static/N0149-500a480d81bb8edbd7c19426e5b3981b.png";